import { get } from "./api";
import { showSpinner, hideSpinner } from "./spinner.ducks";
// i18n
import i18n from "../config/translation/i18n";
// Constant
import { FALLBACK_LNG, FALLBACK_LNG_NAME } from "../config/constants";

export const GET_LOGIN_TRANSLATIONS_SUCCESS = `GET_LOGIN_TRANSLATIONS_SUCCESS`;
export const GET_LOGIN_TRANSLATIONS_ERROR = `GET_LOGIN_TRANSLATIONS_ERROR`;

function transformAPIResponseToReducerLocale(res) {
  return res.reduce((acc, curr) => {
    /**
     * if the locale already exists on the initialState, skip it
     */
    // eslint-disable-next-line no-use-before-define
    if (curr.locale === initialState.locales[0].locale) return acc;

    acc.push({
      locale: curr.locale,
      localeName: curr.localeName,
      isDefault: curr.isDefault
    });

    return acc;
  }, []);
}

const initialState = {
  locales: [
    {
      locale: FALLBACK_LNG,
      localeName: FALLBACK_LNG_NAME
    }
  ]
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_LOGIN_TRANSLATIONS_SUCCESS:
      return {
        locales: [...state.locales, ...transformAPIResponseToReducerLocale(payload)]
      };

    default:
      return state;
  }
};

export const saveLoginTranslations = (payload) => ({
  type: GET_LOGIN_TRANSLATIONS_SUCCESS,
  payload
});

export const fetchLoginTranslations = () => async (dispatch) => {
  try {
    const { data } = await dispatch(get(`/localization`));

    // Add translations to i18n
    data.map((t) => i18n.addResourceBundle(t.locale, `translation`, t.translations, true, true));

    dispatch(saveLoginTranslations(data));
  } catch (error) {
    // TODO:Handle error
  }
};

export const fetchTranslationForLocale = (locale) => async (dispatch) => {
  const { language } = i18n;
  let lng;

  if (language) {
    lng = language;
  } else {
    lng = FALLBACK_LNG;
    localStorage.setItem(`i18nextLng`, FALLBACK_LNG);
  }

  try {
    dispatch(showSpinner());
    const { data } = await dispatch(get(`/localization/${lng}`));

    i18n.addResourceBundle(locale, `translation`, data.translations, true, true);
    dispatch(hideSpinner());
  } catch (error) {
    // TODO:Handle error
    dispatch(hideSpinner());
  }
};
